import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ISingleContactRespose, IContact } from "../models/Contact";
import { IDocumentResponse } from "../models/Document";

export default function useContactSingle(contactId: string = "") {
  const { get, getFile, post, put, del, postDocs } = useApiHelper();
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60 * 10; //10 Minutes

  const contact = useQuery(
    ["contact", contactId],
    () => get<ISingleContactRespose>(`/contact/${contactId}`),
    {
      staleTime: staleTime,
      enabled: !!contactId,
      retry: false,
    }
  );

  const update = useMutation(
    (_contact: IContact) => put(`/contact/${_contact.id}`, _contact),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["contacts"]);
      },
    }
  );

  const documents = useQuery({
      queryKey: ["contactDocuments", contactId],
      queryFn: () => get<IDocumentResponse>(`/contact/${contactId}/documents`),
      staleTime: 1000 * 60 * 10, // 10 minutes
      enabled: !!contactId,
  });

  const downloadDoc = useMutation(
    (ids: any) => getFile(`/contact/${ids.contactId}/documents/${ids.docId}`),
    {
      onSuccess: (data: any) => {
        return data;
      },
    }
  );

  const uploadDoc = useMutation(
    (data: any) => postDocs(`/contact/${contactId}/documents`, data),
    {
      onSuccess: (data: any) => {
        queryClient.invalidateQueries(["contactDocuments", contactId]);
        return data;
      },
    }
  );

  const deleteDoc = useMutation(
    (docId: any) => del(`/contact/${contactId}/documents/${docId}`),
    {
      onSuccess: (data: any) => {
        queryClient.refetchQueries(["contactDocuments", contactId]);
        return data;
      },
    }
  );

  return {
    contact,
    update,
    documents,
    deleteDoc,
    downloadDoc,
    uploadDoc
  };
}
